import { createRouter, createWebHistory } from 'vue-router';

import { useAuthStore } from '@/stores/auth.js';

/**
 * Роутинг accreditation-web:
 *   - /login, /auth/callback — bare (без AppShell)
 *   - / — мои кампании: администратор сервиса видит все, остальные — свои
 *   - /events/:id — карточка кампании (участники, настройки, команда)
 *   - /events/:id/desk — стойка аккредитации: поиск, печать, walk-in
 *   - /scan — станция контрольной точки (станционный токен, офлайн)
 *   - /service-admins — администраторы сервиса
 *   - /access-denied — залогинен, но не добавлен ни в одну кампанию
 */
export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'events',
      component: () => import('@/pages/EventsListPage.vue'),
      meta: { requiresAuth: true, requiresAccess: true },
    },
    {
      path: '/events/:id',
      name: 'event-detail',
      component: () => import('@/pages/EventDetailPage.vue'),
      meta: { requiresAuth: true, requiresAccess: true },
    },
    {
      path: '/events/:id/desk',
      name: 'desk',
      component: () => import('@/pages/DeskPage.vue'),
      meta: { requiresAuth: true, requiresAccess: true },
    },
    {
      path: '/service-admins',
      name: 'service-admins',
      component: () => import('@/pages/ServiceAdminsPage.vue'),
      meta: { requiresAuth: true, requiresPlatformAdmin: true },
    },
    {
      // Экран оператора КТ: без Keycloak, вход по станционному токену.
      path: '/scan',
      name: 'scan',
      component: () => import('@/pages/ScanPage.vue'),
      meta: { bare: true },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/LoginPage.vue'),
      meta: { bare: true },
    },
    {
      path: '/auth/callback',
      name: 'auth-callback',
      component: () => import('@/pages/AuthCallbackPage.vue'),
      meta: { bare: true },
    },
    {
      path: '/access-denied',
      name: 'access-denied',
      component: () => import('@/pages/AccessDeniedPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'events' },
    },
  ],
});

router.beforeEach((to) => {
  const auth = useAuthStore();

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: 'login', query: { returnTo: to.fullPath } };
  }
  if (to.name === 'login' && auth.isAuthenticated) {
    return { name: 'events' };
  }
  if (to.meta.requiresPlatformAdmin && !auth.isPlatformAdmin) {
    return { name: 'access-denied' };
  }
  // Доступ есть у администратора сервиса и у любого, кого добавили в команду
  // хотя бы одной кампании. Остальным показываем экран «вас пока не добавили».
  if (to.meta.requiresAccess && !auth.hasAnyAccess) {
    return { name: 'access-denied' };
  }
  return true;
});
